<template>
    <div class="page-inner r" style="min-height: 100vh;">д
        <div class="page-title">
            <h3>{{ $t('message.Видеотека_-_Жанры') }}</h3>
            <div class="page-breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                        <router-link to="/">{{ $t('message.Главная') }}</router-link>
                    </li>
                    <li class="active breadcrumb-item">{{ $t('message.Видеотека_-_Жанры') }}</li>
                </ol>
            </div>
        </div>
        <div id="main-wrapper">
            <b-button :variant="'success'" class="mb-1 float-right" @click="addRow()">
              {{ $t('message.Добавить') }}
            </b-button>
            <b-table id="genre-table" :busy.sync="isBusy" :items="dataProvider" :fields="fields" :current-page="currentPage"
                     :per-page="perPage"
                     :sort-by.sync="sortBy">
                <template slot="sort_order" slot-scope="row">
                  <div v-show = "order_update_id != row.item.id"
                    @click.stop= "updateOrder(row.item)"
                    style="width:65px;cursor:text;text-align:center;border-bottom: 1px dotted #999;">
                     {{row.item.sort_order}}
                  </div>
                  <input v-show = "order_update_id == row.item.id"
                    v-focus="order_update_id == row.item.id"
                    v-model="row.item.sort_order"
                    v-on:blur= "saveOrder(row.item)"
                    @keyup.enter = "saveOrder(row.item)"
                    style="width:65px">
                </template>
                
                <template slot="image_url" slot-scope="data">
                  <img :src="data.item.image_url" :width="64" />
                </template>                

                <template slot="actions" slot-scope="row">
                    <!-- We use @click.stop here to prevent a 'row-clicked' event from also happening -->
                    <!-- <b-button size="sm" @click.stop="viewVodMovies(row.item, row.index, $event.target)" class="mr-1">
                        <i class="fas fa-eye"></i>
                    </b-button> -->
                    <b-button size="sm" @click.stop="editRow(row.item, row.index, $event.target)" class="mr-1">
                        <i class="fas fa-edit"></i>
                    </b-button>
                    <b-button size="sm" @click.stop="deleteRow(row.item, row.index, $event.target)">
                        <i class="fas fa-trash-alt"></i>
                    </b-button>
                </template>
            </b-table>
            <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage"></b-pagination>

            <b-modal 
                    id="genreModalInfo" 
                    @hide="resetModal"   
                    :ok-title="$t('message.Сохранить')"
                     :cancel-title="$t('message.Отмена')"
                     :title="$t('message.Категории_-_Редактирование')"
                     modal-ok
                     modal-cancel
                     @ok="handleOk"
                     no-close-on-esc
                     no-close-on-backdrop
            >
                <VodGenreForm :model="genreModel"></VodGenreForm>
            </b-modal>
            <!-- <b-modal
                    id="modalVodMovies"
                    :ok-title="$t('message.Закрыть')"
                    :title="$t('message.Список_каналов_-_Просмотр')"
                    ok-only
                    size="lg"
            >
                <VodMoviesListForm :model="genreModelVodMovies" :type="'vod_genres'"></VodMoviesListForm>
            </b-modal> -->
        </div>
    </div>
</template>

<script>

    import Vue from 'vue'
    import VodGenreForm from './VodGenreForm'
    // import VodMoviesListForm from './ChannelListForm'
    import debounce from './stolencrap/index'
    import { focus } from 'vue-focus';

    export default {
        name: "VodGenres",
        components: {
            VodGenreForm,
            // VodMoviesListForm,
        },
        data () {
            return {
                isBusy: false,
                sortBy: "sort_order",
                fields: [
                    { key: 'id', sortable: true },
                    { key: "image_url", sortable: false },                    
                    { key: 'name', sortable: true },
                    { key: 'name_en', sortable: true },
                    { key: "sort_order", sortable: true },
                    { key: 'actions', label: '' , tdClass: 'actions'}
                ],
                genreModel: {},
                genreModelVodMovies: {},
                order_update_id: null,
                perPage: 10,
                currentPage: 1,
                totalRows: 0
            }
        },
        methods: {
            dataProvider(ctx) {
                // Here we don't set isBusy prop, so busy state will be handled by table itself
                // this.isBusy = true
                //console.log(ctx)
                let promise = this.$noname.get('vod_genres', {'params': ctx});

                return promise.then((data) => {
                    const items = data.data.items
                    this.totalRows = data.data.total

                    // Here we could override the busy state, setting isBusy to false
                    // this.isBusy = false
                    return (items)
                }).catch(this.$noname.HandleError)
            },
            editRow (item, index, button) {
                this.genreModel = Object.assign({}, item);
                this.$root.$emit('bv::show::modal', 'genreModalInfo', button)
            },
            viewVodMovies (item, index, button) {
                this.genreModelVodMovies = Object.assign({}, item);
                this.$root.$emit('bv::show::modal', 'modalVodMovies', button)
            },
            handleOk (evt) {
                if (
                  this.genreModel.image &&
                  this.genreModel.image.indexOf("data:image") == -1
                ) {
                  this.genreModel.image = null;
                }
                if(this.genreModel.id>0) {
                    this.$noname
                    .patch('vod_genres', this.genreModel.id, this.genreModel)
                    .then(response => {
                        this.$root.$emit('bv::refresh::table', 'genre-table');
                        this.$root.$emit('bv::hide::modal', 'genreModalInfo');
                        Vue.notify({
                            group: 'notify',
                            text: this.$i18n.t('message.Запись_успешно_сохранена'),
                            type: 'success',
                        });
                        //window.location.href = redirectUrl
                    }).catch(error => {
                        Vue.notify({
                            group: 'notify',
                            text: this.$i18n.t('message.Ошибка_сохранения') + ':<br>'+error,
                            type: 'error',
                        });
                    })
                }
                else
                {
                    this.$noname.post('vod_genres', this.genreModel
                    ).then(response => {
                        this.$root.$emit('bv::refresh::table', 'genre-table');
                        this.$root.$emit('bv::hide::modal', 'genreModalInfo');
                        Vue.notify({
                            group: 'notify',
                            text: this.$i18n.t('message.Запись_успешно_сохранена'),
                            type: 'success',
                        });


                        //window.location.href = redirectUrl
                    }).catch(error => {
                        Vue.notify({
                            group: 'notify',
                            text: this.$i18n.t('message.Ошибка_сохранения') + ':<br>'+error,
                            type: 'error',
                        });
                    })
                }
            },
            resetModal() {
            },
            addRow () {
                this.genreModel = {};
                this.$root.$emit('bv::show::modal', 'genreModalInfo')
            },
            updateOrder(genre) {
              this.order_update_id = genre.id;
            },
            saveOrder(genre) {
                if (genre.sort_order === "" || isNaN(genre.sort_order)) {
                  Vue.notify({
                      group: "notify",
                      text: this.$i18n.t('message.Неверное_значение'),
                      type: "warning"
                    });
                    return;
                };

                this.$noname
                  .patch("vod_genres", genre.id, {sort_order: genre.sort_order})
                  .then(response => {
                    this.order_update_id = null;
                    this.$root.$emit("bv::refresh::table", "genre-table");
                    Vue.notify({
                      group: "notify",
                      text: this.$i18n.t('message.Порядок_сохранён'),
                      type: "success"
                    });
                  })
                  .catch(error => {
                    Vue.notify({
                      group: "notify",
                        text: this.$i18n.t('message.Ошибка_сохранения') + ':<br>'+error ,
                      type: "error"
                    });
                  });
            },
            deleteRow (item, index, button) {
                this.$dialog.confirm(this.$i18n.t('message.Действительно_удалить_категорию?'))
                    .then(response => {
                        this.$noname.delete('vod_genres', item.id
                        ).then(response => {
                            this.$root.$emit('bv::refresh::table', 'genre-table');
                            Vue.notify({
                                group: 'notify',
                                text: this.$i18n.t('message.Запись_успешно_удалена'),
                                type: 'success',
                            });


                            //window.location.href = redirectUrl
                        }).catch(error => {
                            Vue.notify({
                                group: 'notify',
                                text: this.$i18n.t('message.Ошибка_удаления_записи') + ':<br>' + error,
                                type: 'error',
                            });
                        })
                    })

            },
        },
        directives: {debounce, focus}
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/modules/VodGenres.vue